




























































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import SaveButton from '@/components/App/SaveButton.vue';
import draggable from 'vuedraggable';
import PhaseListItem from '@/components/Phases/PhaseListItem.vue';
import env from '../env';

@Component({
  components: {
    PhaseListItem,
    SaveButton,
    draggable
  },
  computed: {
    all_phases() {
      return this.$store.state.all_phases;
    },
    all_environments() {
      return this.$store.state.all_environments;
    }
  }
})
export default class PhaseView extends Vue {
  scrollTo: any = '';

  sorted_phases = [];

  async addPhase() {
    const position = this.$store.state.all_phases.length;
    const p = await axios.post(`${env.backend_url}/phase/create`, {
      position
    });
    await this.$store.dispatch('refreshAllPhases');
    return p;
  }

  goToNewPhase() {
    this.scrollTo = document.getElementById('newPhase');
    return this.$vuetify.goTo(this.scrollTo);
  }

  savePositions() {
    const promises: Promise<any>[] = [];
    this.$store.state.all_phases.forEach((phase: any, index: number) => {
      promises.push(axios.post(`${env.backend_url}/phase/update`, { ...phase, position: index }));
    });
    return Promise.all(promises);
  }

  dragPhases() {
    const phases = [...this.$store.state.all_phases];
    phases.forEach((phase, index) => {
      phases[index].position = index;
    });
    this.$store.commit('setPhases', phases);
  }

  async created() {
    this.$emit('showPreloader');
    await this.$store.dispatch('refreshAllPhases');
    this.$emit('loadingFinished');
  }
}
